import api from "./index";

export async function getSettings() {
  return api.get(`/settings`);
}
